import React from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import "@/App.css";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { CartProvider } from "@/context/CartContext";

import Home from "@/pages/Home";
import Catalog from "@/pages/Catalog";
import Search from "@/pages/Search";
import ProductDetail from "@/pages/ProductDetail";
import Cart from "@/pages/Cart";
import Checkout from "@/pages/Checkout";
import PaymentSuccess from "@/pages/PaymentSuccess";
import PaymentCancel from "@/pages/PaymentCancel";
import Privacy from "@/pages/Privacy";
import FreePdfs from "@/pages/FreePdfs";
import AdminPdfs from "@/pages/admin/Pdfs";

import AdminLogin from "@/pages/admin/Login";
import AdminDashboard from "@/pages/admin/Dashboard";
import AdminProducts from "@/pages/admin/Products";
import ProductForm from "@/pages/admin/ProductForm";
import Offers from "@/pages/admin/Offers";
import Categories from "@/pages/admin/Categories";
import HomeConfig from "@/pages/admin/HomeConfig";
import AdminOrders from "@/pages/admin/Orders";
import OrderDetail from "@/pages/admin/OrderDetail";
import AdminShipping from "@/pages/admin/Shipping";
import ImportEbay from "@/pages/admin/ImportEbay";

function AdminRoute({ children }) {
  const { user } = useAuth();
  if (user === null) return <div className="min-h-screen flex items-center justify-center text-slate-500">Caricamento...</div>;
  if (!user || user.role !== "admin") return <Navigate to="/admin/login" replace />;
  return children;
}

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <CartProvider>
          <Toaster position="top-center" richColors />
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/catalogo" element={<Catalog />} />
            <Route path="/catalogo/:slug" element={<Catalog />} />
            <Route path="/ricerca" element={<Search />} />
            <Route path="/prodotto/:id" element={<ProductDetail />} />
            <Route path="/carrello" element={<Cart />} />
            <Route path="/checkout" element={<Checkout />} />
            <Route path="/pagamento/successo" element={<PaymentSuccess />} />
            <Route path="/pagamento/annullato" element={<PaymentCancel />} />
            <Route path="/privacy" element={<Privacy />} />
            <Route path="/pdf-gratuiti" element={<FreePdfs />} />
            <Route path="/admin/pdf" element={<AdminRoute><AdminPdfs /></AdminRoute>} />

            <Route path="/admin/login" element={<AdminLogin />} />
            <Route path="/admin" element={<AdminRoute><AdminDashboard /></AdminRoute>} />
            <Route path="/admin/prodotti" element={<AdminRoute><AdminProducts /></AdminRoute>} />
            <Route path="/admin/prodotti/importa-ebay" element={<AdminRoute><ImportEbay /></AdminRoute>} />
            <Route path="/admin/prodotti/nuovo" element={<AdminRoute><ProductForm /></AdminRoute>} />
            <Route path="/admin/prodotti/:id" element={<AdminRoute><ProductForm /></AdminRoute>} />
            <Route path="/admin/offerte" element={<AdminRoute><Offers /></AdminRoute>} />
            <Route path="/admin/categorie" element={<AdminRoute><Categories /></AdminRoute>} />
            <Route path="/admin/home" element={<AdminRoute><HomeConfig /></AdminRoute>} />
            <Route path="/admin/ordini" element={<AdminRoute><AdminOrders /></AdminRoute>} />
            <Route path="/admin/ordini/:id" element={<AdminRoute><OrderDetail /></AdminRoute>} />
            <Route path="/admin/spedizioni" element={<AdminRoute><AdminShipping /></AdminRoute>} />

            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </CartProvider>
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
